import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KakobuySpreadsheetGuide from "../pages/article/kakobuy-spreadsheet-guide/page";
import VigorbuySpreadsheet from "../pages/article/vigorbuy-spreadsheet/page";
import QCSpreadsheetGuide from "../pages/article/qc-spreadsheet-guide/page";
import ShoppingSafetyGuide from "../pages/article/shopping-safety-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/vigorbuy-spreadsheet",
    element: <VigorbuySpreadsheet />,
  },
  {
    path: "/qc-spreadsheet-guide",
    element: <QCSpreadsheetGuide />,
  },
  {
    path: "/shopping-safety-guide",
    element: <ShoppingSafetyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;